import styled from '@emotion/styled';

export const ConfirmationText = styled.p`
  padding: 12px;
  font-size: 12px;
  color: #000;
`;
